import { Alert, Collapse } from '@mui/material';
import { useEffect, useState } from 'react';

interface FloatingMswFallbackNoticeProps {
  readonly visible: boolean;
}

export function FloatingMswFallbackNotice({ visible }: FloatingMswFallbackNoticeProps) {
  const [isOpen, setIsOpen] = useState(visible);

  useEffect(() => {
    setIsOpen(visible);
  }, [visible]);

  return (
    <Collapse in={isOpen}>
      <Alert
        severity="warning"
        onClose={() => setIsOpen(false)}
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16,
          zIndex: 9999,
          maxWidth: 460,
          boxShadow: 6,
        }}
      >
        Mock Service Worker could not start for this standalone session. The app is running with real API calls.
      </Alert>
    </Collapse>
  );
}
